module.exports = __webpack_public_path__ + "static/media/heartEyes.ea51bc65.png";